export const MSG_CODE = {
    notLoggedIn: 'NOT_LOGGED_IN',
    logout: 'LOGOUT',
    connectLogout: 'CONNECT_LOGOUT',
    error: 'ERROR'
}